import { FaClock, FaCalendarAlt, FaInfoCircle } from "react-icons/fa";

const ExamNotStarted = () => {
    return (
        <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 9999 }}>
            <div className="w-4/5 max-w-2xl bg-var(--background-color) border border-var(--border-color) rounded-2xl p-12 text-center relative overflow-hidden shadow-2xl">
                {/* Decorative background elements */}
                <div className="absolute top-0 left-0 w-full h-2 bg-blue-500"></div>
                <div className="absolute top-4 right-4 w-16 h-16 bg-blue-500 rounded-full opacity-20"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-blue-500 rounded-full opacity-15"></div>
                
                {/* Clock Icon */}
                <div className="relative z-10 mb-8">
                    <div className="w-24 h-24 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                        <FaClock className="text-white text-4xl" />
                    </div>
                </div>

                {/* Content */}
                <div className="relative z-10">
                    <h2 className="text-4xl font-bold text-var(--text-color) mb-4">Exam Not Started Yet</h2>
                    <p className="text-lg text-var(--text-color) opacity-80 mb-8 leading-relaxed">
                        The exam session has not begun yet. Please wait for the scheduled start time.
                    </p>

                    {/* Info Box */}
                    <div className="mb-8 p-6 bg-var(--background-color) border border-var(--border-color) rounded-xl">
                        <div className="flex items-center justify-center mb-4">
                            <FaCalendarAlt className="text-blue-500 text-2xl mr-3" />
                            <FaInfoCircle className="text-blue-500 text-2xl" />
                        </div>
                        <p className="text-lg text-var(--text-color) opacity-80 leading-relaxed">
                            Please check your exam schedule and return at the designated time.
                        </p>
                    </div>

                    {/* Additional Info */}
                    <div className="mt-8 p-4 bg-var(--background-color) border border-var(--border-color) rounded-lg">
                        <p className="text-sm text-var(--text-color) opacity-70">
                            You will be able to access the exam once the scheduled time arrives.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExamNotStarted;
